var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE812",
    d: "M8.765 6.93q.366-.423.771-.81c-4.096-.128-2.901 2.83-4.243 5.833c-1.534 3.463.185 4.783 2.747 5.19a5.5 5.5 0 0 1-.865-1.414C5.512 13.646 6.18 9.84 8.765 6.93m9.865 3.686c-.381 1.071-1.08 2.276-2.07 3.459a9.9 9.9 0 0 1-2.515 2.177a6.8 6.8 0 0 1-3.712 1.05a14.5 14.5 0 0 1-2.293-.159a4.7 4.7 0 0 0 1.535 1.2c3.707 1.787 3.943-1.534 7.864-3.219c2.203-.947 2.211-2.798 1.191-4.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE809",
    d: "M14.045 7.157a5 5 0 0 1 1.53.54a8.56 8.56 0 0 1 3.055 2.919c.669-1.877.36-3.352-1.101-3.622c-1.607-.29-2.863-.385-4.071-1.225c-1.483-1.037-2.786-.695-3.918.351l.245.013c1.568.09 3.064.394 4.26 1.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEC21C",
    d: "M8.765 6.93c-2.585 2.914-3.253 6.716-1.59 8.803a6.32 6.32 0 0 1 .355-5.666c1.402-2.318 4.209-3.33 6.515-2.91c-1.196-.63-2.692-.934-4.26-1.028L9.54 6.12a11 11 0 0 0-.775.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5CB22",
    d: "M15.575 7.697a4.9 4.9 0 0 0-1.53-.54c1.573.827 2.614 2.22 2.605 4.436a5.55 5.55 0 0 1-2.605 4.659a9.9 9.9 0 0 0 2.515-2.177a11.7 11.7 0 0 0 2.07-3.46a8.55 8.55 0 0 0-3.055-2.913z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCA727",
    d: "M13.783 15.197A3.84 3.84 0 0 1 8.5 14.062c-1.144-1.762-.579-4.033 1.14-5.255c1.92-1.363 4.389-.827 5.289 1.136c.874 1.907.634 4.114-1.145 5.254m.257-8.04c-2.301-.42-5.108.592-6.51 2.906a6.32 6.32 0 0 0-.355 5.67c.218.514.51.994.865 1.414c.716.112 1.5.155 2.293.155c1.419 0 2.687-.386 3.712-1.05a5.55 5.55 0 0 0 2.605-4.659c.013-2.216-1.032-3.609-2.605-4.436z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxg);
export default __webpack_public_path__ + "static/media/paxg.34c005fc5bb7b6c7174695cdfda899ab.svg";
export { ForwardRef as ReactComponent };